import axios from 'axios';

// import Vue from 'vue'

const baseUrl = process.env.NODE_ENV == 'development' ?'https://api-bs-test.tlhcxm.top':'https://api-bs.tlhcxm.top';
axios.defaults.baseURL = baseUrl;
axios.defaults.timeout = 10000;
axios.defaults.headers = {
	'Content-Type': 'application/json'
};

// 请求拦截
axios.interceptors.request.use(config=>{
	
	let data = localStorage['login']?JSON.parse(localStorage['login']):null;
	if(typeof data !='undefined'&& data!=null){
		config.headers['token'] = data.token;
	}
	return config;
},
err=>{
	return Promise.reject(err);
}
);

// 响应拦截
axios.interceptors.response.use(response=>{
	// console.info(response)
	// 当token无效时  清除本地localStorage 内的token,改为从url获取最新token
	if(response.data.code === -2 ||response.data.msg == 'Token无效,请先登录'){
		localStorage.removeItem('token');
	}
	return response.data;
	}
);
export default {
	get(url, params){
		return axios({
			method:'get',
			baseURL: baseUrl,
			url,
			params,
		})
	},
	
	post(url, data) {
		return axios({
		method:'post',
		baseURL: baseUrl,
		url,
		data:data,
		})
	},


}
